export default __webpack_public_path__ + "static/media/fireworks.ed3015b3.svg";